import React from "react";
import { CheckCircle2 } from "lucide-react";

const StepCompanyType = ({ formData, updateFormData, COMPANY_TYPES }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
        Select Company Type
      </h3>

      <p className="text-slate-500 dark:text-slate-400 text-sm mb-6">
        Choose the type that best describes the business
      </p>

      <div className="grid md:grid-cols-3 gap-4">
        {COMPANY_TYPES.map((type) => {
          const isSelected = formData.PROFILE_CATEGORY === type.id;

          return (
            <div
              key={type.id}
              onClick={() => updateFormData("PROFILE_CATEGORY", type.id)}
              className={`
                relative p-5 rounded-2xl border cursor-pointer
                transition-all duration-200 group

                ${
                  isSelected
                    ? `
                      border-teal-500
                      bg-teal-50 dark:bg-teal-500/10
                      shadow-lg shadow-teal-500/10
                    `
                    : `
                      border-slate-200 dark:border-slate-700
                      bg-white dark:bg-slate-800
                      hover:border-slate-300 dark:hover:border-slate-600
                      hover:shadow-md
                    `
                }
              `}
            >
              {/* Selected Icon */}
              {isSelected && (
                <div className="absolute top-3 right-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-500" />
                </div>
              )}

              {/* Icon */}
              <div
                className={`
                  w-12 h-12 rounded-xl
                  bg-gradient-to-br ${type.color}
                  flex items-center justify-center
                  mb-4
                  shadow-sm
                `}
              >
                <type.icon className="w-6 h-6 text-white" />
              </div>

              {/* Content */}
              <h4
                className={`
                  text-base font-semibold mb-1 transition-colors
                  ${
                    isSelected
                      ? "text-teal-700 dark:text-teal-400"
                      : "text-slate-900 dark:text-white"
                  }
                `}
              >
                {type.name}
              </h4>

              <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                {type.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepCompanyType;
